import React from 'react';
import { Redirect } from 'react-router-dom';
import _ from 'lodash';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { getQueryStringParameter } from '../utilities/commonUtil';
import { DIRECT_REDIRECT_SENDER } from '../utilities/constants';

export class DirectOauth extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: undefined,
    };

    this.authProvider = this.props.authProvider;
  }

  async componentDidMount() {
    const linkKey = this.props.match.params.parameter;
    const sender = DIRECT_REDIRECT_SENDER;
    const loginId = decodeURIComponent(this.props.match.params.loginId);
    const code = getQueryStringParameter('code');
    const state = getQueryStringParameter('state');
    const error = getQueryStringParameter('error');

    const relayPoint = {
      linkKey,
      sender,
      loginId,
    };

    const directOauthInfo = {
      code,
      state,
      error,
      linkKey,
      loginId,
    }

    SessionStorageService.setRelayPoint(relayPoint);
    SessionStorageService.setDirectOauthInfo(directOauthInfo);

    const loggedInUser = await this.authProvider.getLoggedInUser();

    this.setState({ user: loggedInUser });
  }

  render() {
    //クライアントが認証状態でなかった場合、ログインページに移動し、ログイン後にランディングページにリダイレクトさせる。
    if (_.isUndefined(this.state.user)) {
      return <div>ログイン情報の確認中です...</div>;
    }

    if (_.isNull(this.state.user)) {
      this.authProvider.redirectLoginPage();
      return <div>ログイン情報の確認中です...</div>;
    }

    return <Redirect to='/callback' />;
  }
}



// WEBPACK FOOTER //
// ./src/components/DirectOauth.js